import { createArray } from 'helpers';

export const tests: GameTestsSetup = {
    // Custom
    antExplorerCarrier: {
        snapshot: {
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 24, y: 24 } }
                    ],
                    explorers: {
                        created: 2,
                        mutations: 2,
                    },
                },
                foods: {
                    active: [
                        { type: 'bread2', props: { calories: 100, x: 20, y: 20 } },
                        { type: 'bread2', props: { calories: 100, x: 15, y: 15 } },
                        { type: 'bread2', props: { calories: 100, x: 10, y: 10 } },
                        { type: 'bread2', props: { calories: 100, x: 5, y: 5 } },
                        { type: 'bread2', props: { calories: 100, x: 0, y: 0 } },
                    ],
                },
            },
            unlocks: {
                colonyHealth: true,
                currentRate: true,
                portfolioTool: true,
            },
        },
    },
    antWorkerMaxDistance: {
        snapshot: {
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 49, y: 24 } }
                    ],
                },
                foods: {
                    active: [
                        { type: 'bread2', props: { x: 49, y: 24 } },
                    ],
                },
            },
        },
    },
    antWorkerRetargetChance: {
        snapshot: {
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 40, y: 24 } }
                    ],
                },
                dangers: {
                    active: [
                        { type: 'antWorker', props: { x: 30, y: 42 } }
                    ],
                },
                foods: {
                    active: [
                        { type: 'bread1', props: { x: 14, y: 42 } },
                        { type: 'bread2', props: { x: 24, y: 42 } },
                        { type: 'bread1', props: { x: 30, y: 24 } },
                        { type: 'bread2', props: { x: 40, y: 24 } },
                    ],
                },
            },
        },
    },

    // Event based
    createdFirstAntWorker: {
        snapshot: {
            calories: 175,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 24, y: 24 } }
                    ],
                },
            },
            turns: 5,
        },
    },
    consumedFirstFood: {
        snapshot: {
            calories: 400,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 29, y: 29 } },
                        { type: 'worker', props: { x: 28, y: 29 } },
                        { type: 'worker', props: { x: 27, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } }
                    ],
                },
            },
            turns: 30,
        },
    },
    foundBigFood: {
        snapshot: {
            calories: 275,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 19, y: 31 } },
                        { type: 'worker', props: { x: 21, y: 29 } },
                        { type: 'worker', props: { x: 23, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } },
                        ...createArray(8, () => ({ type: 'worker', props: { x: 24, y: 24 } })),
                    ],
                },
            },
            turns: 50,
        },
    },
    createDangerAntWarrior: {
        snapshot: {
            calories: 650,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 19, y: 32 } },
                        { type: 'worker', props: { x: 21, y: 29 } },
                        { type: 'worker', props: { x: 23, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } },
                        ...createArray(16, () => ({ type: 'worker', props: { x: 24, y: 24 } })),
                    ],
                },
                dangers: {
                    active: [
                        ...createArray(6, () => ({ type: 'antWorker', props: { x: 16, y: 34 } })),
                        ...createArray(6, () => ({ type: 'antWorker', props: { x: 18, y: 36 } })),
                    ],
                },
            },
            turns: 85,
        },
    },
    unlockPortfolioTool: {
        snapshot: {
            calories: 1000,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 19, y: 32 } },
                        { type: 'worker', props: { x: 21, y: 29 } },
                        { type: 'worker', props: { x: 23, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } },
                        ...createArray(16, () => ({ type: 'worker', props: { x: 24, y: 24 } })),
                        ...createArray(5, () => ({ type: 'warrior', props: { x: 24, y: 24 } })),
                    ],
                    warriors: {
                        allocation: 0,
                    },
                    workers: {
                        allocation: 0,
                    },
                },
                dangers: {
                    active: [
                        ...createArray(10, () => ({ type: 'antWorker', props: { x: 16, y: 34 } })),
                        ...createArray(10, () => ({ type: 'antWorker', props: { x: 18, y: 36 } })),
                        ...createArray(5, () => ({ type: 'antWarrior', props: { x: 18, y: 35 } })),
                    ],
                },
            },
            turns: 120,
        },
    },
    createDangerAnteater: {
        snapshot: {
            calories: 600,
            caloriesReserve: 200,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 19, y: 32 } },
                        { type: 'worker', props: { x: 21, y: 29 } },
                        { type: 'worker', props: { x: 23, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } },
                        ...createArray(20, () => ({ type: 'worker', props: { x: 22, y: 28 } })),
                        ...createArray(8, () => ({ type: 'warrior', props: { x: 24, y: 24 } })),
                    ],
                    warriors: {
                        allocation: 0.3,
                    },
                    workers: {
                        allocation: 0.7,
                    },
                },
                dangers: {
                    active: [
                        ...createArray(24, () => ({ type: 'antWorker', props: { x: 18, y: 35 } })),
                        ...createArray(8, () => ({ type: 'antWarrior', props: { x: 18, y: 35 } })),
                    ],
                },
            },
            turns: 145,
        },
    },
    unlockAntExplorer: {
        snapshot: {
            calories: 600,
            caloriesReserve: 200,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 19, y: 32 } },
                        { type: 'worker', props: { x: 21, y: 29 } },
                        { type: 'worker', props: { x: 23, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } },
                        ...createArray(22, () => ({ type: 'worker', props: { x: 22, y: 28 } })),
                        ...createArray(12, () => ({ type: 'warrior', props: { x: 24, y: 24 } })),
                    ],
                    warriors: {
                        allocation: 0.3,
                    },
                    workers: {
                        allocation: 0.7,
                    },
                },
                dangers: {
                    active: [
                        ...createArray(26, () => ({ type: 'antWorker', props: { x: 18, y: 35 } })),
                        ...createArray(12, () => ({ type: 'antWarrior', props: { x: 18, y: 35 } })),
                        { type: 'anteater', props: { killsTarget: 35, x: 16, y: 30 } },
                    ],
                },
            },
            turns: 200,
        },
    },
    magicFood: {
        snapshot: {
            calories: 600,
            caloriesReserve: 200,
            turns: 200,
        },
    },
    createRandomDangerOnIdle: {
        snapshot: {
            calories: 600,
            caloriesReserve: 200,
            entities: {
                ants: {
                    active: [
                        { type: 'worker', props: { x: 19, y: 32 } },
                        { type: 'worker', props: { x: 21, y: 29 } },
                        { type: 'worker', props: { x: 23, y: 27 } },
                        { type: 'worker', props: { x: 25, y: 25 } },
                        ...createArray(22, () => ({ type: 'worker', props: { x: 22, y: 28 } })),
                        ...createArray(12, () => ({ type: 'warrior', props: { x: 24, y: 24 } })),
                    ],
                    warriors: {
                        allocation: 0.3,
                    },
                    workers: {
                        allocation: 0.7,
                    },
                },
                dangers: {
                    active: [
                        ...createArray(26, () => ({ type: 'antWorker', props: { x: 18, y: 35 } })),
                        ...createArray(12, () => ({ type: 'antWarrior', props: { x: 18, y: 35 } })),
                        { type: 'anteater', props: { killsTarget: 35, x: 16, y: 30 } },
                    ],
                },
            },
            turns: 199,
        },
    },
    createdParadiseAntExplorer: {
        snapshot: {
            calories: 1000,
            caloriesReserve: 200,
            entities: {
                ants: {
                    active: [
                        ...createArray(10, () => ({ type: 'worker', props: { x: 20, y: 30 } })),
                        ...createArray(5, () => ({ type: 'warrior', props: { x: 20, y: 30 } })),
                        { type: 'explorer', props: { role: 'river', x: 20, y: 30 } },
                    ],
                    warriors: {
                        allocation: 0.3,
                    },
                    workers: {
                        allocation: 0.6,
                    },
                    explorers: {
                        allocation: 0.1,
                        mutations: 2,
                        created: 2,
                    },
                },
                dangers: {
                    active: [
                        ...createArray(20, () => ({ type: 'antWorker', props: { x: 18, y: 32 } })),
                        ...createArray(15, () => ({ type: 'antWarrior', props: { x: 18, y: 32 } })),
                    ],
                },
            },
            turns: 250,
        },
    },
    createdGardeningAntExplorer: {
        snapshot: {
            calories: 1000,
            caloriesReserve: 200,
            entities: {
                ants: {
                    active: [
                        ...createArray(10, () => ({ type: 'worker', props: { x: 20, y: 30 } })),
                        ...createArray(5, () => ({ type: 'warrior', props: { x: 20, y: 30 } })),
                        { type: 'explorer', props: { mutation: 'gardening', x: 20, y: 30 } },
                    ],
                    warriors: {
                        allocation: 0.3,
                    },
                    workers: {
                        allocation: 0.6,
                    },
                    explorers: {
                        allocation: 0.1,
                        mutations: 10,
                        created: 10,
                    },
                },
                dangers: {
                    active: [
                        ...createArray(20, () => ({ type: 'antWorker', props: { x: 18, y: 32 } })),
                        ...createArray(15, () => ({ type: 'antWarrior', props: { x: 18, y: 32 } })),
                    ],
                },
            },
            turns: 250,
        },
    },
    victory: {
        snapshot: {
            calories: 1000,
            caloriesReserve: 200,
            entities: {
                ants: {
                    active: [
                        ...createArray(10, () => ({ type: 'worker', props: { x: 24, y: 24 } })),
                        ...createArray(5, () => ({ type: 'warrior', props: { x: 24, y: 24 } })),
                        ...createArray(3, () => ({ type: 'explorer', props: { x: 24, y: 24 } })),
                        { type: 'queen', props: { x: 24, y: 24 } }
                    ],
                },
                dangers: {
                    active: [
                        ...createArray(10, () => ({ type: 'antWorker', props: { x: 18, y: 32 } })),
                        ...createArray(5, () => ({ type: 'antWarrior', props: { x: 18, y: 32 } })),
                    ],
                },
            },
            turns: 500,
        },
    },
};
